import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { INROUTES } from './../common/links';

import Footer from './../components/Footer';
import getDeviceType from './../utils/getDeviceType';

import IcDafthings from './../assets/icon/bi-dafthings.svg';
import IcSearch from './../assets/icon/ic-search.svg';
import IcDownload from './../assets/icon/ic-download.svg';
import { replaceImagesWithInlineSVG } from './../common/replaceImagesWithInlineSVG';

const osList = ['ios', 'android'];

const FindMyDevice = () => {
  const [tabvalue, setTabvalue] = useState('android');

  const changeTabvalue = (value) => {
    setTabvalue(value);
  }

  useEffect(() => {
    let type = getDeviceType();
    if (type === "pc"){ type = "android"}
    setTabvalue(type);
    replaceImagesWithInlineSVG('img.svg');
  }, []);

  function downloadHTML() {
    const filePath = '/FindMyDevice.html';
    const xhr = new XMLHttpRequest();
    xhr.open('GET', filePath, true);
    xhr.responseType = 'blob';

    xhr.onload = function () {
      if (xhr.status === 200) {
        const blob = new Blob([xhr.response], { type: 'text/html' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'FindMyDevice.html';
        link.click();
      }
    };

    xhr.send();
  }

  const IosTab = () => {
    return (
      <div className="content-group">                                 
          <div className="paragraph">
              <p className="step">02</p>
              <p className="desc"><strong className="ios-etc hidden">Safari 브라우저에서 </strong>아래의 버튼을 눌러 주소를 찾아 보세요.</p>
          </div>        
          <div className="button-box">
              <Link to={INROUTES.FINDMYDEVICE_SCAN} className="btn point" target="_self" rel="noopener noreferrer">
              <button type="button" name="link" value="findMyDevice"><i className="icon"><img src={IcSearch} alt="Search" className="svg"/></i><strong className="name">IP SCAN</strong></button>
              </Link>
          </div>
      </div>
    )
  }

  const AndroidTab = () => {
    return (
      <div className="content-group">                                 
          <div className="paragraph">
              <p className="step">02</p>
              <p className="desc"><strong>다운로드</strong> 후 파일을 <strong>실행</strong>해 주세요.</p>
          </div>        
          <div className="button-box">
              <button type="button" name="download" value="findMyDevice" className="btn point" onClick={downloadHTML}><i className="icon"><img src={IcDownload} alt="Download" className="svg"/></i><strong className="name">DOWNLOAD</strong></button>
          </div>
      </div>
    )
  }
  
  const renderTabContent = () => {
    switch (tabvalue) {
      case 'ios':
        return <IosTab />;
      case 'android':
        return <AndroidTab />;
      default:
        return null;
    }
  };
    return (
      <div id="app">
        <header id="header">
          <div className="wrap flx">
            <Link to={INROUTES.HOME}>
            <button type="button" className="logo" name="page"><span className="icon"><img src={IcDafthings} alt="DafThings" className="svg"/></span></button></Link>
            <span className="blank"></span>
          </div>
        </header>
        <section id="container" className="wrap">
          <div className="paragraph">
            <h2 className="title">디바이스 주소 찾기</h2>
            <p className="desc">
                아래의 디바이스 주소 찾기 또는 공유기를 통해서 직접 디바이스의 주소를 찾을 수 있습니다.<br/><br/><span className="bu">* 주소를 찾은 후 바로 가기 아이콘을 생성하여 쉽게 접속하세요.</span>
            </p>
          </div>
          <div className="button-box tab">
            <button className={`btn ${tabvalue === osList[0] ? 'active-tab' : ''}`} name="page-content" onClick={() => changeTabvalue(osList[0])}><span className="name">iOS 사파리</span></button>
            <button className={`btn ${tabvalue === osList[1] ? 'active-tab' : ''}`} name="page-content" onClick={() => changeTabvalue(osList[1])}><span className="name">안드로이드 / 윈도우</span></button>
          </div>
          <div className="content-group">                        
            <div className="paragraph">
                <p className="step">01</p>
                <p className="desc">디바이스를 찾으려면, <strong>해당 기기와 동일한 네트워크</strong>에 연결되어 있어야 합니다.<br/>다시 말해, 같은 공유기로 구성된 동일한 네트워크를 사용해야 합니다.</p>
            </div>      
          </div> 
          {renderTabContent()}
          <span className="empty-space"></span>
        </section>
        <Footer page={"none"} />
      </div>
    );
};

export default FindMyDevice;